import React from 'react'
import { Badge, CardBody, Card, Input } from 'reactstrap';
import { SearchAsync } from '../../../../components/elements/SearchAsync';
import { almas, pyrsa } from '../../../../constant/globalConstantsTypeClients';
import { MultiSelect } from 'primereact/multiselect';
import '../SampleDeterminations/StyleTableDetermination.css'
import { FaLayerGroup } from "react-icons/fa";
import { FaFlask } from "react-icons/fa";

export const TableDeterminations = (props) => {

    const {
        isClientSelected, formQuoterMic, searchSampleState, handleSelectMuestra,
        handleSelectDetermination, examProfileState,
        handleDeleteQuantity, handleAddQuantity, handleViewExamsProfile,
        url_helen, handleSearchRules, handleRemoveDeterminacion, listRules,
        handleDeleteTypeSample,
        handleChangeQuantity,
        checkTypeClient,
        handleObservations, handleViewNorms, openDeleteSampleAlert, openDeleteDeterminacionAlert
    } = props;



    // console.log("LISTA COMPLETA", formQuoterMic.list_type_samples);
    return (
        <Card
            className={`helen-card determination-card ${!isClientSelected ? "card-disabled-ios" : ""
                }`}
        >
            <CardBody>


                <div className="matrix-header">
                    <div className="matrix-icon">
                        <i className="fa fa-flask"></i>
                    </div>

                    <div className="matrix-title">
                        MUESTRAS Y DETERMINACIONES
                        <small>
                            Añade y utiliza el buscador para asignar estudios a las muestras.
                        </small>
                    </div>

                    <div className="matrix-actions">
                        <div className="matrix-select">
                            <SearchAsync
                                cacheOptions={false}
                                value={formQuoterMic.type_sample_select}
                                name="id_sample"
                                method={handleSelectMuestra}
                                loincState={searchSampleState}
                                url="TypeSamples/SearchTypeSample"
                                maxLenght={3}
                                placeholder="Búsqueda de muestras"
                            />
                        </div>
                    </div>
                </div>

            </CardBody>

            <div className="determination-main-header">

                <span>
                    Detalle de Determinaciones
                </span>

                <Badge className="determination-badge">
                    {formQuoterMic.list_type_samples.length} muestras
                </Badge>

            </div>

            <div className="mobile-table-scroll">
                <div className="table-mobile-width">


                    <div className="determination-columns">
                        <div>ABREV.</div>
                        <div>DETERMINACIÓN</div>
                        <div>METODOLOGÍA</div>
                        <div>
                            {checkTypeClient === 1
                                ? "OBSERVACIONES"
                                : "CONVENIO"}
                        </div>
                        <div>COSTO</div>
                        <div>ACCIONES</div>
                    </div>
                    <div className="determination-scroll-area">

                        {formQuoterMic.list_type_samples.length > 0 ? (
                            formQuoterMic.list_type_samples.map((sample, i) => {
                                const sampleLocked = sample.list_determinations?.some(
                                    det => det.collected_id && det.collected_id !== "N/A"
                                );

                                return (

                                    <div
                                        key={i}
                                        className={`sample-block ${sampleLocked ? "sample-locked" : ""}`}
                                    >


                                        <div className="sample-header-row">

                                            <div className="sample-section-title">
                                                <span className="sample-water-icon">
                                                    <i className="fa fa-flask"></i>
                                                </span>

                                                <span className="sample-name">
                                                    {sample.name_sample}

                                                    {sampleLocked && (
                                                        <i
                                                            className="fa fa-ban text-danger"
                                                            title="Muestra ya enviada a muestreo, no puede ser editada"
                                                        />
                                                    )}
                                                </span>


                                            </div>

                                            <div className="sample-search-container">
                                                <div
                                                    className={`sample-search-container ${sampleLocked ? "disabled-search" : ""
                                                        }`}
                                                >
                                                    <SearchAsync
                                                        value={formQuoterMic.id_exam_temp}
                                                        method={(e) =>
                                                            !sampleLocked && handleSelectDetermination(e, i)
                                                        }
                                                        loincState={examProfileState}
                                                        url="Profiles/SearchProfileExam"
                                                        maxLenght={3}
                                                        selectSize="col-md-12"
                                                        name="is_Micro"
                                                        is_micro={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="sample-counter">

                                                <button
                                                    className="counter-action minus"
                                                    disabled={sampleLocked}
                                                    onClick={() => handleDeleteQuantity(i)}
                                                >
                                                    <i className="fa fa-minus"></i>
                                                </button>

                                                <input
                                                    type="number"
                                                    min="1"
                                                    className="counter-display-input"
                                                    value={sample.cant || 1}
                                                    disabled={sampleLocked}
                                                    onChange={(e) =>
                                                        handleChangeQuantity(
                                                            i,
                                                            parseInt(e.target.value || 1)
                                                        )
                                                    }
                                                />
                                                <button
                                                    className="counter-action plus"
                                                    disabled={sampleLocked}
                                                    onClick={() => handleAddQuantity(i)}
                                                >
                                                    <i className="fa fa-plus"></i>
                                                </button>

                                            </div>
                                            <span
                                                className="sample-delete-btn"
                                                onClick={() => !sampleLocked && openDeleteSampleAlert(i)}
                                                title={
                                                    sampleLocked
                                                        ? "Muestra enviada a muestreo"
                                                        : "Eliminar muestra"
                                                }

                                            >
                                                <i className="fa fa-trash"></i>
                                            </span>

                                        </div>
                                        {sample.list_determinations?.map((det, index) => (

                                            <div
                                                className="determination-row"
                                                key={index}
                                            >

                                                {/* ABREVIATURA */}

                                                 <div className="det-abrev">
                                                    {det.abbreviation}
                                                </div>
                                                
                                                {/* DETERMINACIÓN */}

                                              <div className="det-name">

                                                    {det.id_profile ? (
                                                        <span className="profile-pill-quoter-mic profile">
                                                            <FaLayerGroup />
                                                            Perfil
                                                        </span>
                                                    ) : (
                                                        <span className="profile-pill-quoter-mic exam">
                                                            <FaFlask />
                                                            Examen
                                                        </span>
                                                    )}

                                                    <span className="det-title">
                                                        {det.name}
                                                    </span>

                                                </div>
                                             
                                                {/* METODOLOGÍA */}

                                                <div className="det-method">
                                                    {(url_helen === almas || url_helen === pyrsa) ? (
                                                        <div className="norma-container">

                                                            <span
                                                                className="norma-principal"
                                                                title={(det.listNorm || []).map(x => x.name).join(", ")}
                                                            >
                                                                {det.listNorm?.[0]?.name || "Sin metodología"}
                                                            </span>

                                                           {(det.listNorm?.length || 0) > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="profile-badge norma-count-btn"
                                                                    title='Da click para ver las demas normas del estudio'
                                                                    onClick={() => handleViewNorms(det)}>
                                                                    + {det.listNorm.length - 1}
                                                                </button>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <MultiSelect
    value={(det.ids_mic_noms || []).map(String)}
    options={(
        det.listNorm?.length
            ? det.listNorm
            : listRules
    ).map(x => ({
        ...x,
        code: String(x.code)
    }))}
    optionValue="code"
    optionLabel="name"
    selectedItemTemplate={(value) => {
        if (!value) return null;

        const options = det.listNorm?.length
            ? det.listNorm
            : listRules;

        const norma = options.find(
            x => String(x.code) === String(value)
        );

        return (
            <span className="norma-selected-name">
                {norma?.name || value}
            </span>
        );
    }}
    onChange={(e) =>
        handleSearchRules(
            e.value,
            det?.id_exam,
            det?.id_profile,
            i
        )
    }
    placeholder="Selecciona una Norma"
    className="normas-multiselect"
    panelClassName="normas-multiselect-panel"
    filter
/>

                                                        
                                                    )}

                                                </div>

                                                {
                                                    checkTypeClient === 1 ? (



                                                        <Input
                                                            type="textarea"
                                                            name="observations_det"
                                                            rows="3"
                                                            value={det?.observations_det || ""}
                                                            onChange={(e) =>
                                                                handleObservations(
                                                                    e,
                                                                    det?.id_exam,
                                                                    det?.id_profile,
                                                                    sample.id
                                                                )
                                                            }
                                                            style={{ fontSize: "12px" }}

                                                        />

                                                    ) : (

                                                        <div className="det-convenio">
                                                            {det.contract_number}
                                                        </div>

                                                    )
                                                }


                                                <div className="det-price">
                                                    ${parseFloat(det.price || 0).toFixed(2)}
                                                </div>


                                                <div className="det-actions">
                                                    <div className="det-actions">
                                                        <button
                                                            disabled={sampleLocked}
                                                            className="delete-ios-btn"
                                                            onClick={() =>
                                                                openDeleteDeterminacionAlert(
                                                                    i,
                                                                    det.id_exam,
                                                                    det.id_profile,
                                                                    det.name
                                                                )
                                                            }
                                                            title='Eliminar determinación'
                                                        >
                                                            <i className="fa fa-trash" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                );
                            })
                        ) : (
                            <div className="empty-determinations">

                                <div className="floating-circle circle-1"></div>
                                <div className="floating-circle circle-2"></div>
                                <div className="floating-circle circle-3"></div>
                                <div className="floating-circle circle-4"></div>
                                <div className="floating-circle circle-5"></div>

                                <div className="empty-content">
                                    <i className="fa fa-flask"></i>
                                    <h6>Sin determinaciones</h6>
                                    <small>Agregue una determinación para comenzar</small>
                                </div>

                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Card>
    )
}
